import { type ReactNode, useEffect } from 'react';

import { useLocation } from 'react-router-dom';

interface ScrollManagerProps {
    children: ReactNode;
}

const ScrollManager: React.FC<ScrollManagerProps> = ({ children }) => {
    const location = useLocation();
    // const scrollPositions = React.useRef<Record<string, { x: number; y: number }>>({});

    // useEffect(() => {
    //     const { pathname } = location;

    //     // Save the current scroll position before navigating away
    //     const saveScrollPosition = () => {
    //         scrollPositions.current[pathname] = {
    //             x: window.scrollX,
    //             y: window.scrollY,
    //         };
    //     };

    //     // Restore the scroll position on route change
    //     const restoreScrollPosition = () => {
    //         const position = scrollPositions.current[pathname];
    //         if (position) {
    //             window.scrollTo(position.x, position.y);
    //         } else {
    //             window.scrollTo(0, 0);
    //         }
    //     };

    //     restoreScrollPosition();
    //     window.addEventListener('beforeunload', saveScrollPosition);

    //     return () => {
    //         saveScrollPosition();
    //         window.removeEventListener('beforeunload', saveScrollPosition);
    //     };
    // }, [location]);

    useEffect(() => {
        const state = location.state as { scrollPosition?: { x: number; y: number } };

        if (state?.scrollPosition) {
            const { x, y } = state.scrollPosition;
            window.scrollTo(x, y);
        } else {
            window.scrollTo(0, 0);
        }
    }, [location]);


    return <>{children}</>;
};

export default ScrollManager;
